/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/* eslint-disable react/boolean-prop-naming */
/*
 * @category  Puma
 * @author    Deniss Dubinins <denissd@scandiweb.com | info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2022 Scandiweb, Inc (https://scandiweb.com)
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import NationalIdNumber from './NationalIdNumber.component';

/** @namespace Nationalidnumber/Component/NationalIdNumber/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    grand_total: state.CartReducer.cartTotals?.grand_total,
    national_id_number_enabled: state.ConfigReducer.national_id_number_enabled,
    national_id_number_min_order_amount: state.ConfigReducer.national_id_number_min_order_amount
});

/** @namespace Nationalidnumber/Component/NationalIdNumber/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Nationalidnumber/Component/NationalIdNumber/Container */
export class NationalIdNumberContainer extends PureComponent {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        grand_total: PropTypes.number.isRequired,
        national_id_number_enabled: PropTypes.bool.isRequired,
        national_id_number_min_order_amount: PropTypes.string.isRequired
    };

    render() {
        return <NationalIdNumber { ...this.props } />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NationalIdNumberContainer);
